import React from "react";

const MyBuyers = () => {
  return (
    <div>
      <h1>My Buyers</h1>
    </div>
  );
};

export default MyBuyers;
